import { Button } from '@platform/components';
import { isTypeLargeCta } from '@platform/contentful';
import { Entry } from 'contentful';

const ContentfulLargeCta = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeLargeCta(entry)) {
    return null;
  }

  return (
    <div className='w-fit'>
      {/* TODO: Apply specific size & color based on Contentful values */}
      <Button
        variant='primary'
        size='2xl'
        href={entry.fields.url}
        target={entry.fields.openInNewTab ? '_blank' : '_self'}
      >
        {entry.fields.text}
      </Button>
    </div>
  );
};

export default ContentfulLargeCta;
